
import * as imagekitRuntime$EZCYQvyEUP from '/vercel/path0/node_modules/.pnpm/@nuxt+image@1.3.0_@types+node@22.10.5_db0@0.3.4_ioredis@5.11.1_supports-color@10.2.2__magicast@0.5.4/node_modules/@nuxt/image/dist/runtime/providers/imagekit'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "imagekit",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['imagekit']: { provider: imagekitRuntime$EZCYQvyEUP, defaults: {"baseURL":"https://ik.imagekit.io/9c2qah8ie"} }
}
        